import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';

export const getDetailWaitHappy = (id) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': `/happyWaiting/list?id=${id}`,
      'authenticated': true,
      'types': [
        ActionTypes.FETCHING_DETAIL_WAIT_HAPPY,
        ActionTypes.FETCHED_DETAIL_WAIT_HAPPY,
        [ActionTypes.FETCHED_DETAIL_WAIT_HAPPY_FAILED,
          (error) => buildErrorMessage(error)],
      ],
      'microservice': 'part',
      'method': 'GET',
    })
  );
};
